import React, { useEffect, useState, useRef } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import LoadingBox from '../../Component/LoadingBox';
import MessageBox from '../../Component/MessageBox';
import { RequestQuoteButton } from '../../Component/RequestQuoteButton';

import { detailsOrder } from '../../redux/actions/orderAction';


import Shipping from './Shipping';
//import Payment from './Payment';
import OrderItems from './OrderItems';
import OrderSummary from './OrderSummary';
import { ORDER_PAY_REQUEST } from '../../redux/constant/orderConstant';

import './PlaceOrderScreen.less';

//* Error Boundary para capturar errores en RequestQuoteButton
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error capturado en RequestQuoteButton:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <MessageBox variant="danger">
          Error al cargar el botón de cotización:{' '}
          {this.state.error?.message || 'Error desconocido'}
        </MessageBox>
      );
    }

    return this.props.children;
  }
}

export default function OrderScreen() {
  const { id } = useParams();
  const orderId = id;

  const dispatch = useDispatch();

  const orderDetails = useSelector(state => state.orderDetails);
  const { loading, error, order } = orderDetails;

  const orderPay = useSelector(state => state.orderPay);
  const { loading: loadingPay, success: successPay } = orderPay;

  //* Esta variable se crea para no repetir el valor de successPay /

  const [localSuccessPay, setLocalSuccessPay] = useState(successPay);

  //* SOLO se mantiene el estado necesario para el SDK de PayPal/pago
  const [sdkReady, setSdkReady] = useState(false);

  //* Flag para evitar llamadas duplicadas
  const fetchedRef = useRef(null);

  //* 1. Cargar Datos de la Orden
  useEffect(() => {
    if (fetchedRef.current === orderId) {
      return;
    }
    //* Si orderId es válido. Y (no hay orden 0 la orden ers diferente)
    // if (orderId && orderId !== 'undefined') {
    if (!orderId || Object.keys(order).length === 0 || order._id !== orderId) {
      //* if (!order?._id || !order._id || orderId !== order._id) {
      //   if (!order?._id || orderId !== order._id) {
      //console.log('🔵 Fetching order:', orderId);
      fetchedRef.current = orderId; //* Marcar como fetched ANTES de la dispatch
      dispatch(detailsOrder(orderId));
    }
    //  }
    else {
      //! 3. Configurar PayPal SDK si la orden no está pagada se puede eliminar o cambiar
      if (!orderId.isPaid) {
        if (sdkReady === false) {
          if (typeof window.paypal !== 'undefined') {
            addPayPalScript();
          }
        }
      } else {
        setSdkReady(true);
      }
    }
  }, [dispatch, orderId]); //* ← REMOVER 'order' de las dependencias

  //* Manejo de ID no válido (MANTENER)
  if (!orderId || orderId === 'undefined') {
    return (
      <MessageBox variant="danger">ID de orden no válido o ausente.</MessageBox>
    );
  }

  return loading ? (
    <LoadingBox />
  ) : error ? (
    <MessageBox variant="danger">{error}</MessageBox>
  ) : !order ? (
    <MessageBox variant="danger">Orden no encontrada</MessageBox>
  ) : (
    //* 2. RENDERIZAR_PANTALLA
    <div>
      <h1>Order {orderId}</h1>

      <div className="products top">
        <div className="col-2">
          <ul>
            {/* 2.2 Renderizar sección SHIPPING */}
            <li>
              <div className="order order-body">
                <h2>Shipping</h2>
                {/* 2.2 se agrega el componente  SHIPPING */}
                <Shipping
                  shippingAddress={order.shippingAddress}
                  isDelivered={order.isDelivered}
                  delivereAt={order.delivereAt}
                />
                {/* <p>
                  <strong>Name:</strong> {order.shippingAddress.fullName} <br />
                  <strong>Address: </strong> {order.shippingAddress.address},
                  {order.shippingAddress.city},
                  {order.shippingAddress.postalCode},
                  {order.shippingAddress.country}
                </p> */}
                {order.isDelivered ? (
                  <MessageBox variant="success">
                    Delivered at {order.deliveredAt}
                  </MessageBox>
                ) : (
                  <MessageBox variant="danger">Not Delivered</MessageBox>
                )}
              </div>
            </li>

            {/* 2.3 Renderizar sección PAYMENT */}
            <li>
              <div className="order order-body">
                <h2>Payment</h2>
                <p>
                  <strong>Method:</strong> {order.paymentMethod}
                </p>
                {order.isPaid ? (
                  <MessageBox variant="success">
                    Paid at {order.paidAt}
                  </MessageBox>
                ) : (
                  <MessageBox variant="danger">Not Paid</MessageBox>
                )}
              </div>
            </li>

            {/*  2.4 Renderizar sección ORDER ITEMS */}
            <li>
              <div className="order order-body">
                <h2>Order Items</h2>
                {/*  2.5 Remplazamos el detalle por el componente OrderItems */}

                <OrderItems orderItems={order.orderItems} />
              </div>
            </li>
          </ul>
        </div>

        {/* COLUMNA DERECHA: Resumen y Pago */}
        <div className="col-1">
          <div className="order order-body">
            <ul>
              {/* 2.5 Renderizar sección ORDER SUMMARY */}
              <li>
                <h2>
                  <strong>Order Summary</strong>
                </h2>
              </li>
              <li>
                <div className="products">
                  <div>Items</div>
                  <div>${(order.itemsPrice || 0).toFixed(2)}</div>
                  {/* toFixed(2) agregado aquí para consistencia */}
                </div>
              </li>
              <li>
                <div className="products">
                  <div>Shipping </div>
                  <div>${(order.shippingPrice || 0).toFixed(2)}</div>
                </div>
              </li>
              <li>
                <div className="products">
                  <div>Tax</div>
                  <div>${(order.taxPrice || 0).toFixed(2)}</div>
                </div>
              </li>
              <li>
                <div className="products">
                  <div>
                    <strong>Order Total</strong>
                  </div>
                  <div>
                    <strong>${(order.totalPrice || 0).toFixed(2)}</strong>
                  </div>
                </div>
              </li>

              {/* 2.6 Renderizar RequestQuoteButton o PayPal */}
              {!order.isPaid && (
                <li>
                  <div className="products">
                    <ErrorBoundary>
                      <RequestQuoteButton orderId={orderId} />
                    </ErrorBoundary>
                  </div>
                </li>
              )}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
